// extracted by mini-css-extract-plugin
export default {"modal":"ModalTablet_modal__89C+v","backdrop":"ModalTablet_backdrop__YLuIh","tablet":"ModalTablet_tablet__nGpdr","screen":"ModalTablet_screen__At1F4"};